export default {
  'validators.tinNumberFormat':
    '请输入正确的TIN号码格式（如 123-456-789-001 或 123-456-789-12345）',
  'validators.phoneNumberFormat': '请输入正确的菲律宾手机号码格式',
};
